module.exports = __webpack_public_path__ + "img/about-us.8c34c5e6.svg";